var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReferenceMultipleSelect',{staticClass:"ma-0",attrs:{"label":"Направление","resource":"countries"},on:{"input":_vm.changeDirections},model:{value:(_vm.directions),callback:function ($$v) {_vm.directions=$$v},expression:"directions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }